import CTABarAdapter from "./CTABar";

export { CTABarAdapter as CTABar };
